import React from 'react'

import styled from '@emotion/styled'
import { mq, black02, dot, hoverFade, green01, fontEn } from '../../_style'
import { Link } from 'gatsby';
import imgIconTwitter from '../../assets/imgs/icon-twitter.svg';
import imgIconFb from '../../assets/imgs/icon-fb.svg';
import imgIconLine from '../../assets/imgs/icon-line.svg';
import Logo from '../atoms/logo';
import BannerList from '../molecules/bannerList';
import FooterVisual from './footerVisual';
import ContentWidth from './contentWidth';
import { animateScroll as scroll } from 'react-scroll';
import GlobalFooter from './globalFooter';

const Container = styled.div`
  overflow: hidden;
`
const Inner = styled.div`
  position: relative;
  padding: 29px 0 30px;
  background: ${green01};
  color: #fff;
  ${mq.sp} {
    padding: 43px 20px 43px;
  }
`

const Foot = styled.div`
  position: relative;
  width: 100%;
  ${mq.pc} {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  & > ul {
    ${mq.pc} {
      display: none;
    }
    ${mq.sp} {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: -28px;
      & > li {
        width: 50%;
        margin-bottom: 28px;
        font-size: 11px;
        line-height: 1;
      }
    }
  }
`

const Sns = styled.div`
  ${mq.pc} {
    display: flex;
    align-items: center;
  }
  ${mq.sp} {
    font-size: 0;
    text-align: center;
  }
  & > p {
    font-size: 15px;
    letter-spacing: 0.1em;
    line-height: 1;
    ${mq.pc} {
      margin-right: 14px;
    }
    ${mq.sp} {
      margin-bottom: 21px;
      font-size: 12px;
      text-align: center;
    }
  }
`

const SnsIcon = styled.a`
  display: block;
  width: 25px;
  height: 25px;
  background-image: url(${props => props.imgSrc});
  background-size: contain;
  background-position: center;
  ${props => props.onlySp && `${mq.pc} {display: none;}`}
  ${hoverFade}
  ${mq.sp} {
    display: inline-block;
    &:not(:last-child) {
      margin-right: 30px;
    }
  }
  ${mq.pc} {
    &:not(:last-child) {
      margin-left: 20px;
    }
  }
`

const FooterLogo = styled.div`
  position: relative;
  ${mq.sp} {
    margin-bottom: 60px;
  }
  a {
    display: block;
    ${hoverFade}
    svg {
      display: block;
      width: 115px;
      height: 60px;
      ${mq.sp} {
        width: 120px;
        height: 62px;
        margin: 0 auto;
      }
    }
  }
`;


const Right = styled.div`
  ${mq.pc} {
    display: flex;
  }
`
const PageTop = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -25px;
  right: 30px;
  width: 50px;
  height: 50px;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.09);

  ${mq.pc} {
    &:hover {
      animation: hover 0.7s ease;
    }
  }
  ${mq.sp} {
    top: -23px;
    right: 20px;
    width: 46px;
    height: 46px;
  }
  svg {
    width: 20px;
    ${mq.sp} {
      width: 22px;
    }
  }
  @keyframes hover {
    0% {
      transform: translate3d(0, 0, 0);
    }
    50% {
      transform: translate3d(0, -10px, 0);
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  }
`

export default class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isMenuOpen: false, activeMenuNum: 0};
  }
  menuHandler(isOpen) {
    this.setState({isMenuOpen: isOpen});
  }
  changeMenuBg(num) {
    this.setState({activeMenuNum: num});
  }
  scrollTop() {
    scroll.scrollToTop();
  }
  render() {
    return(
      <>
        <Container>
          <ContentWidth spread>
            <BannerList banners={[
              {
                href: 'https://www.earth.jp/dental/index.html',
                img: 'img-banner-dental',
                alt: 'デンタル',
                isBlank: true
              },{
                to: '/premiumcare',
                img: 'img-banner-all-in-one',
                alt: 'プレミアム',
                isNew: false
              }, {
                href: 'https://www.earth.jp/mondahmin-kids/index.html',
                img: 'img-banner-kids',
                alt: 'キッズ',
                isBlank: true
              }]} inMenu>
            </BannerList>
          </ContentWidth>
          <FooterVisual></FooterVisual>
          <Inner>
            <ContentWidth>
              <Foot>
                <FooterLogo>
                  <Link to="/">
                    <Logo color={'#fff'}></Logo>
                  </Link>
                </FooterLogo>
                <Right>
                  <Sns>
                    <p>このページをシェア</p>
                    <SnsIcon href="https://twitter.com/share?url=https://www.earth.jp/mondahmin/&text=%e5%8f%a3%e8%87%ad%e3%80%81%e6%ad%af%e8%82%89%e7%82%8e%e3%80%81%e3%82%80%e3%81%97%e6%ad%af%e3%81%aa%e3%81%a9%e3%81%ae%e3%81%8a%e5%8f%a3%e3%83%88%e3%83%a9%e3%83%96%e3%83%ab%e4%ba%88%e9%98%b2%e3%81%ab%20%e3%83%a2%e3%83%b3%e3%83%80%e3%83%9f%e3%83%b3%20%7c%20%e3%82%a2%e3%83%bc%e3%82%b9%e8%a3%bd%e8%96%ac" target="_blank" imgSrc={imgIconTwitter}><div></div></SnsIcon>
                    <SnsIcon href="https://www.facebook.com/share.php?u=https://www.earth.jp/mondahmin/" target="_blank" imgSrc={imgIconFb}><div></div></SnsIcon>
                    <SnsIcon href="http://line.me/R/msg/text/?%e5%8f%a3%e8%87%ad%e3%80%81%e6%ad%af%e8%82%89%e7%82%8e%e3%80%81%e3%82%80%e3%81%97%e6%ad%af%e3%81%aa%e3%81%a9%e3%81%ae%e3%81%8a%e5%8f%a3%e3%83%88%e3%83%a9%e3%83%96%e3%83%ab%e4%ba%88%e9%98%b2%e3%81%ab%20%e3%83%a2%e3%83%b3%e3%83%80%e3%83%9f%e3%83%b3%20%7c%20%e3%82%a2%e3%83%bc%e3%82%b9%e8%a3%bd%e8%96%ac https://www.earth.jp/mondahmin/" target="_blank" imgSrc={imgIconLine} onlySp><div></div></SnsIcon>
                  </Sns>
                </Right>
              </Foot>
            </ContentWidth>
            <PageTop onClick={() => this.scrollTop()}>
              <svg xmlns="http://www.w3.org/2000/svg" width="22.31" height="11.31" viewBox="0 0 22.31 11.31">
                <path d="M21.15 10.81l-9.99-8.97-10 8.97" fill="none" stroke="#00ab84" />
              </svg>
            </PageTop>
          </Inner>
        </Container>
      </>
    )
  }
}
